<template>
    <div class="content form-group">
            <div class="row header">
                <div class="col-1 text-center align-self-center">
                    <i class="fa fa-mobile"></i>
                </div>
                <div class="col-10 align-self-center pr-0">
                    <span class="font-weight-bold"> {{ $t('mobileAppHeader') | upperCase }} </span>
                </div>
            </div>
                <hr />
                <div class="row">
                    <div class="col-md-12">
                        <img class="mobile-app-img" src="../../assets/fiaMobileApp.png" />
                    </div>
                    <div class="col-md-12 text-justify text-muted small">
                        <span>{{ $t("mobileAppDescription") }}</span>
                    </div>
                </div>
                <hr />
                <div class="row">
                    <div class="col-6 pr-2 text-right">
                        <a href="https://apps.apple.com/gb/app/fia-fbih/id1522853101?ign-mpt=uo%3D2" target="_blank">
                            <img class="store-img" src="../../assets/appStore.png"/>
                        </a>
                    </div>
                    <div class="col-6 pl-2 text-left">
                        <a href="https://play.google.com/store/apps/details?id=ba.fia.portal" target="_blank">
                            <img class="store-img" src="../../assets/playStore.png"/>
                        </a>
                    </div>
                </div>
        </div>
</template>

<script>
    
    export default {
        filters: {
            upperCase(value) {
                return value.toUpperCase();
            }
        }
    }
</script>

<style scoped>
    .content {
        border-radius: 5px;
        padding: 5%;
        background-color: #FFF;
        box-shadow: 0px 2px 6px 1px rgba(0,0,0,0.15);
        border-top: 1px solid rgba(0,0,0,0.06);
    }

    .store-img {
        height: 90%;
        width: 80%;
        opacity: 0.8;
    }

    .store-img:hover {
        opacity: 1;
    }

    .mobile-app-img {
        width: 100%;
    }

    .content {
        font-size: 15px;
    }

    .fa {
        font-size: 35px;
    }
</style>

